import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroBanners } from '@/mocks/comics';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const goTo = useCallback((index: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrent(index);
    setTimeout(() => setIsTransitioning(false), 600);
  }, [isTransitioning]);

  useEffect(() => {
    const timer = setInterval(() => {
      goTo((current + 1) % heroBanners.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [current, goTo]);

  const banner = heroBanners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroBanners.map((b, idx) => (
        <div
          key={b.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            idx === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={b.image}
            alt={b.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}
      <div className={`absolute inset-0 bg-gradient-to-b ${banner.color}`}></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="animate-fade-in-up max-w-xl" key={banner.id}>
              <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight">
                {banner.title}
              </h2>
              <p className="mt-3 md:mt-4 text-sm md:text-base text-white/80 leading-relaxed">
                {banner.subtitle}
              </p>
              <div className="flex flex-wrap gap-3 mt-5 md:mt-6">
                <Link
                  to={`/article/${banner.comicId}`}
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  <i className="ri-book-read-line"></i>
                  立即阅读
                </Link>
                <Link
                  to="/category/all"
                  className="inline-flex items-center gap-2 px-5 py-2.5 bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full text-sm font-medium hover:bg-white/30 transition-colors whitespace-nowrap"
                >
                  <i className="ri-apps-line"></i>
                  浏览全部
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroBanners.map((_, idx) => (
          <button
            key={idx}
            onClick={() => goTo(idx)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              idx === current ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/70'
            }`}
            aria-label={`切换到第${idx + 1}张横幅`}
          />
        ))}
      </div>
    </section>
  );
}